const mEditionBillingAcademySalesRecordModalCancelSubscription = {
  mEditionBillingAcademySalesRecordModalCancelSubscription: {
    alerts: {
      updateSubscription: {
        error: 'Un error ha ocurrido. Verifica que la sucripción este activa.',
        success: 'Se canceló en forma exitosa la suscripción.',
        successGateway: 'Solicitud de cancelación exitosa. Deberás esperar la confirmación de la pasarela de pago.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CONFIRMAR',

    title: 'Deseas cancelar la suscripción!'
  }
}

export default mEditionBillingAcademySalesRecordModalCancelSubscription
